var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEnum, IsNotEmpty, IsOptional, IsString, IsUUID, MaxLength } from 'class-validator';
import { Role } from '../../roles/index.js';
export class CreateFileUploadDto {
    originalFilename;
    filename;
    blob;
    createdBy;
    createdByRole;
    patientId;
    officeId;
}
__decorate([
    IsString(),
    MaxLength(255),
    __metadata("design:type", String)
], CreateFileUploadDto.prototype, "originalFilename", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreateFileUploadDto.prototype, "filename", void 0);
__decorate([
    IsNotEmpty(),
    __metadata("design:type", Object)
], CreateFileUploadDto.prototype, "blob", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CreateFileUploadDto.prototype, "createdBy", void 0);
__decorate([
    IsOptional(),
    IsEnum(Role),
    __metadata("design:type", String)
], CreateFileUploadDto.prototype, "createdByRole", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CreateFileUploadDto.prototype, "patientId", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CreateFileUploadDto.prototype, "officeId", void 0);
//# sourceMappingURL=create-file-upload.js.map